export const DEFAULT_CITY = 'ekb';
export const CITY_SLUG_COOKIE_KEY = 'city_slug';
export const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';
